import { BARS_AND_SECTORS_ES_ES } from "#pages/place/bars/translations/bars-and-sectors-es-es";
import { IMPORT_ES_ES } from "#pages/place/purchase-invoice/import-invoice/translations/import-es-es";
import { PURCHASE_INVOICE_ES_ES } from "#pages/place/purchase-invoice/translations/purchase-invoice-es-es";
import { TEAM_ES_ES } from "#pages/team/translations/team-es-es";
import { merge } from "lodash-es";
import es_MXJson from "../es-MX/es-MX.json";
import { delivery } from "../es-MX/place/delivery";
import { backofficeEsES as backoffice } from "./backoffice";
import { components } from "./components";
import { precharge_ES_MX as precharge } from "#pages/place/precharge/pages/translations";
import { event } from "./event";
import { navES } from "./nav";
import { integrations } from "./org/integrations";
import { clientArea } from "./org/client-area";
import { noAuthESES as noAuth } from "./no-auth";
import { emissionErrors } from "./place/emission-errors";
import { tableRangeSettings } from "./place/products/bars/table-range-settings";
import { REGISTER_EMAIL_ES_ES } from "./recovery/register-email";
import { TRANSACTIONS_REPORT_ES_ES } from "#components/transactions-report/translations";
import { BONUS_CATEGORIES_ES_ES } from "#pages/place/bonus-categories/translations";
import { settings } from "./place/settings";

const es_ES = merge(es_MXJson, {
	components,
	backoffice,
	place: {
		purchaseInvoiceV2: PURCHASE_INVOICE_ES_ES,
		import: IMPORT_ES_ES,
		delivery,
		barsAndSectors: BARS_AND_SECTORS_ES_ES,
		emissionErrors,
		precharge,
		products: {
			bars: {
				tableRangeSettings,
			},
		},
		transactionsReport: TRANSACTIONS_REPORT_ES_ES,
		bonusCategories: BONUS_CATEGORIES_ES_ES,
		settings,
	},
	recovery: {
		registerEmail: REGISTER_EMAIL_ES_ES,
	},
	event,
	team: TEAM_ES_ES,
	nav: navES,
	noAuth,
	org: {
		integrations,
		clientArea,
	},
});

export { es_ES };
